// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonDateLine{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30px;
    position: relative;
    --width: 70px;
    color: #000000;
}

.commonDateLine_box{
    width: 100%;
    height: 0px;
    border-bottom: 1px solid #E1E1E3;
}

.commonDateLine_label{
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    width: var(--width);
    height: 30px;

    background: #FFFFFF;
    border: 1px solid #E1E1E3;
    border-radius: 30px;

    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    cursor: pointer;
}

.commonDateLine--thin{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30px;
    position: relative;
    --width: 70px;
}

.commonDateLine_box--thin{
    width: 100%;
    height: 0px;
    border-bottom: 1px solid #E1E1E3;
}

.commonDateLine_label--thin{
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    width: var(--width);
    height: 20px;

    /*background-color: #f6f6f9;*/
    background-color: #f9f9f6;
    border: none;
    border-radius: 30px;

    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    gap: 4px;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/dateLine/DateLine.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;;IAEZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;;IAEZ,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;;IAEnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,eAAe;AACnB","sourcesContent":[".commonDateLine{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 30px;\n    position: relative;\n    --width: 70px;\n    color: #000000;\n}\n\n.commonDateLine_box{\n    width: 100%;\n    height: 0px;\n    border-bottom: 1px solid #E1E1E3;\n}\n\n.commonDateLine_label{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    position: absolute;\n    width: var(--width);\n    height: 30px;\n\n    background: #FFFFFF;\n    border: 1px solid #E1E1E3;\n    border-radius: 30px;\n\n    font-weight: 700;\n    font-size: 11px;\n    line-height: 15px;\n    cursor: pointer;\n}\n\n.commonDateLine--thin{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 30px;\n    position: relative;\n    --width: 70px;\n}\n\n.commonDateLine_box--thin{\n    width: 100%;\n    height: 0px;\n    border-bottom: 1px solid #E1E1E3;\n}\n\n.commonDateLine_label--thin{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    position: absolute;\n    width: var(--width);\n    height: 20px;\n\n    /*background-color: #f6f6f9;*/\n    background-color: #f9f9f6;\n    border: none;\n    border-radius: 30px;\n\n    font-weight: 700;\n    font-size: 11px;\n    line-height: 15px;\n    gap: 4px;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
